import React from 'react';
import { __ } from '@wordpress/i18n';

// store
import { storeSet, useStoreValue } from '../../../../../../store';

// components
import Button3d from '../../../../../../components/ButtonWrapper/components/Button3d';
import CaretLeftIcon from '../../../../../../icons/CaretLeftIcon';

const SubPageTitle = () => {
    const myStudioLeftPanel = useStoreValue('myStudioLeftPanel');
    const myStudioMusicPanel = useStoreValue('myStudioMusicPanel');
    const myStudioAudioPanel = useStoreValue('myStudioAudioPanel');

    const handleChangeMusicPanelState = (value) => {
        storeSet('myStudioMusicPanel', value);
    }

    const handleChangeAudioPanelState = (value) => {
        storeSet('myStudioAudioPanel', value);
    }

    return (
        <div className="timelineEditorAuxControls__subPageTitle">
            <div className="timelineEditorAuxControls__subPageTitleHeading">
                <button className="button-icon" onClick={() => {
                    storeSet('myStudioLeftPanel', '')
                }}>
                    <CaretLeftIcon/>
                </button>
                <span>{myStudioLeftPanel === 'video' ? __('Recent Video', 'soundbetween') : null}</span>
            </div>
            {myStudioLeftPanel === 'music'
                ? <div className="timelineEditorAuxControls__subPageTitleActions">
                    <Button3d
                        changeFn={handleChangeMusicPanelState}
                        name="references"
                        disableUntoggle={true}
                        checked={myStudioMusicPanel === 'references'}>
                        {__('References', 'soundbetween')}
                    </Button3d>
                    <Button3d
                        changeFn={handleChangeMusicPanelState}
                        name="soundtrack"
                        disableUntoggle={true}
                        checked={myStudioMusicPanel === 'soundtrack'}>
                        {__('Soundtrack', 'soundbetween')}
                    </Button3d>
                </div>
                : null}
            {myStudioLeftPanel === 'audio'
                ? <div className="timelineEditorAuxControls__subPageTitleActions">
                    <Button3d
                        changeFn={handleChangeAudioPanelState}
                        name="sfx"
                        disableUntoggle={true}
                        checked={myStudioAudioPanel === 'sfx'}>
                        {__('SFX', 'soundbetween')}
                    </Button3d>
                    <Button3d
                        changeFn={handleChangeAudioPanelState}
                        name="mix"
                        disableUntoggle={true}
                        checked={myStudioAudioPanel === 'mix'}>
                        {__('Mix', 'soundbetween')}
                    </Button3d>
                </div>
                : null}
        </div>
    );
};

export default SubPageTitle;
